'use strict';

var array = require('./array.cjs');

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        array.addUniqueItem(this.subscriptions, handler);
        return () => array.removeItem(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

exports.SubscriptionManager = SubscriptionManager;
//# sourceMappingURL=subscription-manager.cjs.map
